import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoProcessoService {

  tipoProcessoGet$ = new BehaviorSubject(null);
  tipoProcessoConfigGet$ = new BehaviorSubject(null);
  tipoProcessoPost$ = new BehaviorSubject(null);
  tipoProcessoPut$ = new BehaviorSubject(null);
  tipoProcessoDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  //Buscar Tipos de Processo
  get() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/TiposProcessos/grid_tipos_de_processos/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.tipoProcessoGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.tipoProcessoGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.tipoProcessoGet$.unsubscribe(),
          this.tipoProcessoGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  //Buscar Tipos de Processo Configurados
  configGet(id_cliente) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/TiposProcessos/tipos_de_processos/" + environment.empresa + "/" + id_cliente;

      this.http.get(url).subscribe({
        next: (data) => this.tipoProcessoConfigGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.tipoProcessoConfigGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.tipoProcessoConfigGet$.unsubscribe(),
          this.tipoProcessoConfigGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  //Inclusão Tipo do Processo
  post(tipo_processo: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/TiposProcessos/IncluirTipoProcesso"
      tipo_processo.empresa = environment.empresa;

      this.http.post(url, tipo_processo, { headers: headers })
        .subscribe({
          next: (res: any) => this.tipoProcessoPost$.next(res),
          error: (error: HttpErrorResponse) => {
            this.tipoProcessoPost$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.tipoProcessoPost$.unsubscribe(),
            this.tipoProcessoPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  //Alterar Tipo do Processo
  put(tipo_processo: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/TiposProcessos/EditarTipoProcesso"
      tipo_processo.empresa = environment.empresa;

      this.http.put(url, tipo_processo, { headers: headers })
        .subscribe({
          next: (res: any) => this.tipoProcessoPut$.next(res),
          error: (error: HttpErrorResponse) => {
            this.tipoProcessoPut$.next(false);
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.tipoProcessoPut$.unsubscribe(),
            this.tipoProcessoPut$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  //Deletar Tipo do Processo
  del(tipo_processo: any) {
    try {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: tipo_processo
      };

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/TiposProcessos/ExcluirTipoProcesso"
      tipo_processo.empresa = environment.empresa;

      this.http.delete(url, options).subscribe({
        next: (res: any) => this.tipoProcessoDelete$.next(res),
        error: (error: HttpErrorResponse) => {
          this.tipoProcessoDelete$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.tipoProcessoDelete$.unsubscribe(),
          this.tipoProcessoDelete$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }
}
